import { RADIUS } from "@/styles";
import { IconButton, Modal as ChakraModal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { useEffect } from "react";
import type { CustomModalProps } from "./types";

export const Modal = ({ children, isOpen, onClose, iconName }: CustomModalProps) => {
    useEffect(() => {
        if (isOpen) {
            const timeoutId = setTimeout(() => {
                const container = document.querySelector(".chakra-modal__content-container") as HTMLElement;

                if (container) container.style.zIndex = "9999";
            }, 0);

            return () => clearTimeout(timeoutId);
        }

        return () => {};
    }, [isOpen]);

    return (
        <ChakraModal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                w="auto"
                h="auto"
                p="0"
                m="0"
                top="50%"
                transform="translateY(-50%) !important"
                sx={{ ...RADIUS(4) }}
            >
                {iconName && (
                    <IconButton
                        aria-label="Close modal"
                        icon={<span className="material-icons">{iconName}</span>}
                        position="absolute"
                        zIndex="9996"
                        top="1rem"
                        right="1rem"
                        onClick={onClose}
                    />
                )}
                <ModalBody p="0">{children}</ModalBody>
            </ModalContent>
        </ChakraModal>
    );
};
